import { CreateESignRequestBody, ESignDocument } from "shared";
import { apiRoutes } from "../../../routing/routes";

export const postESignDocument = async (
  eSignDocument: ESignDocument
): Promise<boolean> => {
  const body: CreateESignRequestBody = {
    PolicyRequiredDocumentPk: eSignDocument.id,
    Source: eSignDocument.source,
  };

  try {
    const response = await fetch(apiRoutes.eSign, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return response.ok;
  } catch {
    return false;
  }
};
